import { GameInstance } from '../../../api/menu/GameMenuItem';

export const parseUtcDate = (dateStr: string) => {
  const normalized = dateStr.endsWith('Z') ? dateStr : dateStr + 'Z';
  return new Date(normalized).getTime();
};

export interface AvailabilityInfo {
  available: boolean;
  timeUntilNextBooking?: number;
}

export const getAvailabilityInfo = (instance: GameInstance): AvailabilityInfo => {
  const nowUtc = Date.now();
  const sortedSlots = [...instance.availability].sort((a, b) => parseUtcDate(a.fromDateTime) - parseUtcDate(b.fromDateTime));

  const currentAvailability = sortedSlots.find((slot) => {
    const from = parseUtcDate(slot.fromDateTime);
    const to = parseUtcDate(slot.toDateTime);
    const bufferMs = 30 * 1000;
    return nowUtc >= from - bufferMs && nowUtc < to && slot.available;
  });

  if (!currentAvailability) return { available: false };

  const nextBooking = sortedSlots.find((slot) => {
    const from = parseUtcDate(slot.fromDateTime);
    return from > nowUtc && !slot.available;
  });

  if (!nextBooking) return { available: true };

  const minutes = Math.floor((parseUtcDate(nextBooking.fromDateTime) - nowUtc) / (1000 * 60));
  if (minutes < 5) return { available: false };

  return { available: true, timeUntilNextBooking: minutes };
};
